<template>
  <div class="installation_target">
    <header-component
      :is-soon="false"
      :backRoute="true"
      :progression="false"
      img-left="/trocachip/img/setinha-left-preto.svg"
      img-right="/trocachip/img/access.png"
      class="header-component"
    />
    <div class="installation_target-img">
      <img src="@/assets/images/phone-small.svg" />
    </div> 
    <div class="installation_target_title">
        <span>{{pageInfo.title}}</span>
    </div>
    <div class="installation_instructions">
      <span class="installation_instructions_span">{{ pageInfo.sub_title }}</span>
    </div>
    <section class="choice_container">
        <button 
            class="choice_buttons" 
            v-for="(validationType, index) in pageInfoChoice" 
            :class="{'last_button': (index + 1) === pageInfoChoice.length}"
            :id="validationType.alt"
            :key="validationType.alt" 
            @click="goToChoice(validationType.alt)"
        >
                <div class="image-container">
                  <img :src="validationType.image" :title="validationType.alt" :alt="validationType.alt" />
                </div>
                <span class="message">{{validationType.title}}</span>
                <img src="@/assets/images/arrow-chevron-right.svg" class="right_arrow_button" />
        </button>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderComponent from "@/components/HeaderComponent.vue";
import trackEvent from "@/services/trackEvent";

export default {
  name: "InstallationTarget",
  components: { HeaderComponent},
  created() {
    this.sendTracker("selecao_aparelho", 6, 3);
  },
  computed: {
    ...mapState({
      ac: (state) => state.ac,
      config: (state) => state.config,
      customer: (state) => state.customer,
      pageInfo: (state) => state.config.installation_target,
      pageInfoChoice: (state) => state.config.installation_target.choice
    }),
  },
  methods: {
    sendTracker(eventLabel, eventCategory = 6, eventAction = 2) {
      trackEvent.track({
        user: {
          login: this.customer.login,
          loginType: this.customer.loginType,
          lineType: this.customer.lineType,
          segment: this.customer.segment,
          subSegment: this.customer.subSegment,
          planCode: this.customer.planCode,
          planName: this.customer.planName,
        },
        channel: trackEvent.getChannel(),
        "event-category": eventCategory,
        "event-label": eventLabel,
        "event-location": "null",
        "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
        "event-status": "Sucesso",
        "event-action": eventAction,
      });
    },
    goToChoice(choice){

    if(choice == "this_device"){
        this.goToThisDevice();
    }
    else if(choice == "another_device"){
        this.goToAnotherDevice();
    }

    },
    goToThisDevice() {
      this.sendTracker("neste_aparelho_selecionar");
      this.$router.push({ name: "QRCodeInstallation" });
    },
    goToAnotherDevice() {
      this.sendTracker("outro_aparelho_selecionar");
      this.$router.push({ name: "anotherDeviceInstallation" });
    },
  },
};
</script>

<style lang="scss" scoped>
.installation_target {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  z-index: -1;
  > .page_content {
    margin: 25% 0%;
  }
  .installation_target-img {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 85px;
}
  .installation_target_title {
    font-weight: 300;
    font-size: 27px;
    line-height: 30px;
    align-items: center;
    display: flex;
    font-family: "timsans_regular";
    width: 280px;
    text-align: center;
    flex-direction: column;
    margin: auto;
    margin-top: 1rem;
  }
  .installation_instructions {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
    text-align: center;
    margin-top: 1rem;
    color: #696969;
    width: 325px;
    margin: auto;
  }
  .installation_instructions_span {
    margin-top: 1rem;
  }
  .choice_container {
  position: absolute;
  width: 100vw;
  margin-top: 24px;

    .choice_buttons {
      border: none;
      border-bottom: 1px solid #e5e5e5;
      background-color: white;
      display: flex;
      align-items: center;
      text-align: start;
      padding: 44px 24px;
      height: 7.2rem;
      width: 100vw;
    }

    .image-container {
      padding: 12px ;
      border-radius: 16px;
      border: 1px solid  #E5E5E5;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .image-container img {
      width: auto;
      height: auto;
    }

    .message {
      padding-left: 1.5rem;
      width: 100%;
      font-family: "timsans_bold";
      font-size: 14px;
      line-height: 21px;
      font-feature-settings: 'salt' on;
    }

    .right_arrow_button {
      float: right;
      margin-left: 24px;
    }
  }


}

</style>